export const ORDER_BY_NEWEST = 'orderByNewest' as const;
export const ORDER_BY_HIGHEST = 'orderByHighest' as const;
export const ORDER_BY_LOWEST = 'orderByLowest' as const;
export const ORDER_BY_IMAGES = 'orderByImages' as const;
export const ORDER_BY_RATING_ALL = 'orderByRatingAll' as const;
export const ORDER_BY_RATING_1 = 'orderByRating1' as const;
export const ORDER_BY_RATING_2 = 'orderByRating2' as const;
export const ORDER_BY_RATING_3 = 'orderByRating3' as const;
export const ORDER_BY_RATING_4 = 'orderByRating4' as const;
export const ORDER_BY_RATING_5 = 'orderByRating5' as const;

export type OrderBy =
    | typeof ORDER_BY_NEWEST
    | typeof ORDER_BY_HIGHEST
    | typeof ORDER_BY_LOWEST
    | typeof ORDER_BY_IMAGES;

export type RatingFilter =
    | typeof ORDER_BY_RATING_ALL
    | typeof ORDER_BY_RATING_1
    | typeof ORDER_BY_RATING_2
    | typeof ORDER_BY_RATING_3
    | typeof ORDER_BY_RATING_4
    | typeof ORDER_BY_RATING_5;

export const RATING_FILTERS_BY_STARS = [
    [5, ORDER_BY_RATING_5],
    [4, ORDER_BY_RATING_4],
    [3, ORDER_BY_RATING_3],
    [2, ORDER_BY_RATING_2],
    [1, ORDER_BY_RATING_1],
] as const satisfies ReadonlyArray<readonly [number, RatingFilter]>;

export const DEFAULT_RATING_FILTER = ORDER_BY_RATING_ALL;
